<ng-http-loader
  [entryComponent]="loadingSpinnerComponent"
  [filteredUrlPatterns]="spinnerFilteredUrlPatterns"
>
</ng-http-loader>
<router-outlet></router-outlet>
